<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let recObjectsStore = getGroupStore('recObjectsStore');
  import BrowserUtils from '@utils/browser-utils';

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let recObjectId;
  export let mobile = false;
  export let style = '';
  export let neighborhoodStyle = '';
  export let showFullAddress = false;
  export let viewStyle = 'column';
  export let includeNeighborhood = false;
  export let inlineConfiguration;

  let address;
  let recObject = recObjectsStore.find(recObjectId);

  let unsubRecObject = recObject.subscribe((x) => {
    recObject = x;

    if (recObject.addresses && recObject.addresses.length > 0) {
      address = recObject.addresses[0];
    } else {
      address = null;
    }
  });

  export let handleClick = function () {
    if (!BrowserUtils.textSelected()) {
      window.open(encodeURI('https://www.google.com/maps/search/?api=1&query=' + address.address));
    }
  };

  let setupAutocomplete = function (node) {
    let inputEl = jQuery(node).children('input')[0];
    return new google.maps.places.Autocomplete(inputEl, {
      types: ['geocode'],
    });
  };

  let removeEmptyValues = function (values) {
    return values.filter((x) => {
      return x !== undefined && x !== null && x !== '';
    });
  };

  let commaSeperateValues = function (values) {
    return removeEmptyValues(values).join(', ');
  };

  onDestroy(() => {
    unsubRecObject();
  });
</script>

<style style="text/scss" lang="scss">
  .neighborhood-container-inside {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .neighborhood {
    color: black;
    opacity: 0.5;
    font-size: 15px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .ui-neighborhood-container {
    margin-top: 25px;
  }

  .mobile {
    /* margin-top: 17px; */
    .neighborhood {
      padding-right: 0px !important;
      font-size: 14px !important;
    }
  }

  .grid {
    margin-top: 16px;

    .neighborhood {
      font-size: 12px;
    }
  }

  .inline-configuration {
    margin-top: 15px;
  }

  .neighborhood-input {
    border: 2px solid transparent;
    width: 100%;
    border-radius: 7px;
    cursor: text;

    &:focus {
      border-color: #a893f9;
      background: #ede9ff;
      caret-color: #a893f9;
      outline: none;
    }

    &:hover {
      background-color: #ede9ff;
      outline: none;
      caret-color: #a893f9;
    }
  }
</style>

{#if address || inlineConfiguration}
  <div
    class:inline-configuration={inlineConfiguration}
    class="ui-neighborhood-container {viewStyle}"
    class:mobile={mobile}
    style={style}>
    <span on:click|preventDefault class="neighborhood-container-inside">
      <svg
        on:click|preventDefault|stopPropagation={handleClick}
        style="flex-shrink: 0; cursor: pointer;"
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 17C7 17 14 12.4667 14 6.8C14 3.04446 10.866 0 7 0C3.13401 0 0
          3.04446 0 6.8C0 12.4667 7 17 7 17ZM9.33341 6.79999C9.33341 8.05184
          8.28875 9.06666 7.00008 9.06666C5.71142 9.06666 4.66675 8.05184
          4.66675 6.79999C4.66675 5.54815 5.71142 4.53333 7.00008
          4.53333C8.28875 4.53333 9.33341 5.54815 9.33341 6.79999Z"
          fill="#D5CFEA" />
      </svg>
      {#if inlineConfiguration}
        <div
          class="neighborhood"
          style="margin-top: 3px; width: calc(100% - 100px); {neighborhoodStyle}"
          use:setupAutocomplete>
          <input
            type="text"
            class="neighborhood-input"
            value={address && address.address}
            placeholder={inlineConfiguration.placeholder}
            on:change={(e) => {
              setTimeout(function () {
                dispatch('inline-edit', {
                  text: e.target.value,
                });
              }, 100);
            }} />
        </div>
      {:else}
        <span
          class="neighborhood"
          style="cursor: pointer; {neighborhoodStyle}"
          on:click|preventDefault|stopPropagation={handleClick}>
          {#if showFullAddress}
            <span>{address.address}</span>
          {:else if includeNeighborhood && address.neighborhood && address.city && address.state_abbr}
            <span>
              {commaSeperateValues([address.neighborhood, address.city, address.state_abbr])}
            </span>
          {:else if address.city && address.state_abbr}
            <span>
              {commaSeperateValues([address.city, address.state_abbr])}
            </span>
          {:else if address.city}
            <span>{address.city}</span>
          {:else}
            <span>{address.country}</span>
          {/if}
        </span>
      {/if}
    </span>
  </div>
{/if}
